var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroupAdd = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4C5.5 5.10457 4.60457 6 3.5 6C2.39543 6 1.5 5.10457 1.5 4C1.5 2.89543 2.39543 2 3.5 2C4.60457 2 5.5 2.89543 5.5 4ZM4.5 4C4.5 4.55228 4.05228 5 3.5 5C2.94772 5 2.5 4.55228 2.5 4C2.5 3.44772 2.94772 3 3.5 3C4.05228 3 4.5 3.44772 4.5 4Z",
    fill: "#32373E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2V3H9V4H10V5H11V4H12V3H11V2H10Z",
    fill: "#32373E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 8.34315 1.34315 7 3 7H4C5.65685 7 7 8.34315 7 10V11H0V10ZM1 10C1 8.89543 1.89543 8 3 8H4C5.10457 8 6 8.89543 6 10H1Z",
    fill: "#32373E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16614 3.40054C6.01235 3.19722 5.82501 3.0336 5.71118 2.95307L6.28874 2.13672C6.47622 2.26936 6.74084 2.50266 6.96369 2.79729C7.18149 3.08523 7.40389 3.49079 7.40389 3.95603C7.40389 4.39058 7.23183 4.79485 7.05451 5.09837C6.87396 5.40742 6.65776 5.66332 6.50251 5.814L5.80603 5.09642C5.90066 5.00458 6.05927 4.81953 6.19106 4.59394C6.32608 4.36283 6.40389 4.13877 6.40389 3.95603C6.40389 3.80397 6.32499 3.61055 6.16614 3.40054Z",
    fill: "#32373E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09644 8.10783C7.29642 8.194 7.6038 8.36734 7.84985 8.59029C8.10927 8.82536 8.20909 9.02993 8.20551 9.18019C8.18762 9.93118 8.19803 10.7128 8.20552 11.0124L9.20521 10.9875C9.198 10.6992 9.18783 9.93452 9.20522 9.204C9.21929 8.61351 8.85242 8.14927 8.52132 7.84926C8.17685 7.53713 7.76988 7.30912 7.49215 7.18945L7.09644 8.10783Z",
    fill: "#32373E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroupAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GroupAdd.112a05ee3f67cd804eaed6ba007b75e7.svg";